import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import InstantSupportDashboard from '../../../PerksHub/InstantSupportDashboard';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { fetchInstantSupport } from './companyPerksApi';

/** Company Perks → Instant Support (EAP): the plan, plus how it gets used. */
const CPerksInstantSupport = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  const fetcher = useCallback(
    () => fetchInstantSupport(department),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Instant Support | Shoorah</title>
      </Helmet>
      <InstantSupportDashboard
        fetcher={fetcher}
        populationLabel={isB2BFansMode ? 'members' : 'employees'}
      />
    </div>
  );
};

export default CPerksInstantSupport;
